/* global utag */

import { h } from 'preact';
import Store from 'store/store';
import * as actions from 'store/actions';
import { accessNested } from 'utils/utils';
import formatDateTime from 'utils/formatDateTime';

import { initTracker } from 'utils/tracking';
if (typeof window !== 'undefined') {
	window.tealiumTrackingAllowed = function() {
		window.preventCookies = false;
		initTracker(Store.get().appData);

		// Update  the firstVisit value in the store
		try {
			let isFirstVisit = localStorage.getItem('isFirstVisit') !== 'false';
			if (isFirstVisit) {
				localStorage.setItem('isFirstVisit', 'false');
			} else {
				const user = Store.get().user;
				if (user) user.set({ isFirstVisit: false });
			}
		} catch (err) {}
	};

	window.utag_cfg_ovrd = { nocookie: true, ...window.utag_cfg_ovrd } || { nocookie: true };
}

const languages = {
	gb: 'en',
	us: 'en',
	au: 'en'
};
const profilesCountries = {
	'emea-powster': [
		'ad', 'ae', 'al', 'ao', 'at', 'ba', 'be', 'bf', 'bg', 'bh', 'bi', 'bj', 'bw', 'by', 'cd', 'cf',
		'ch', 'ci', 'cm', 'cv', 'cy', 'cz', 'de', 'dj', 'dk', 'dz', 'ee', 'eg', 'eh', 'er', 'es', 'et',
		'fi', 'fo', 'fr', 'ga', 'gb', 'ge', 'gg', 'gh', 'gi', 'gm', 'gn', 'gq', 'gr', 'gw', 'hr', 'hu',
		'ie', 'il', 'im', 'iq', 'ir', 'is', 'it', 'je', 'jo', 'ke', 'km', 'kw', 'lb', 'li', 'lr', 'ls',
		'lt', 'lu', 'lv', 'ly', 'ma', 'mc', 'md', 'me', 'mde', 'mg', 'mk', 'ml', 'mr', 'mt', 'mu', 'mw',
		'mz', 'na', 'ne', 'ng', 'nl', 'no', 'om', 'pl', 'ps', 'pt', 'qa', 'ro', 'rs', 'rw', 'sa', 'sd',
		'se', 'si', 'sk', 'sm', 'sn', 'so', 'st', 'sy', 'sz', 'td', 'tg', 'tn', 'tr', 'tz', 'ua', 'ug',
		'va', 'xm', 'ye', 'za', 'zm', 'zw'
	]
};

let staticRender;
let basicTrackingObj = {};

function getTrackingObj(data) {
	return Object.assign({}, basicTrackingObj, data);
}
function theaterData(theater) {
	if (!theater || typeof theater !== 'object') {
		let theaters = Store.get().showtimes.theaters;
		let predicate = t => t.active;
		if (typeof theater === 'string') {
			let id = theater;
			predicate = t => t.id === id;
		}
		theater = theaters.find(predicate);
	}
	if (!theater) return;
	let chain = accessNested(theater, 'exhibitor.domain');
	return {
		cinemaName: theater.name,
		cinemaChain: chain,
		location: theater.location.city
	};
}

// TEALIUM
function pageViewTrack(data = {}) {
	if (!window.utag || typeof utag.view !== 'function') return;
	utag.view(getTrackingObj(data));
}

function actionTrack(data) {
	if (Store.get().appData?.options?.enableEnsighten) {
		return ensightenActionTrack(data);
	}

	if (!window.utag || typeof utag.link !== 'function') return;
	utag.link(getTrackingObj(data));
}

// ENSIGHTEN
const ensightenPageViewTrack = (pageId) => {
	if (!window.__dataLayer) {
		return;
	}

	if (pageId === 'showtimes') {
		pageId = 'tickets';
	}

	const appData = Store.get().appData;
	const siteName = appData.meta?.title?.slug;
	let country = appData.meta?.region?.countryName.toLowerCase();
	if (country === 'gb') {
		country = 'uk';
	}

	window.__dataLayer.page_name = `emea:${country}:${siteName}:${pageId.toLowerCase()}`;
	window.__dataLayer.trackPage();
};

const ensightenActionTrack = eventData => {
	if (!window.__dataLayer || (typeof window.__dataLayer.publish !== 'function')) {
		return;
	}

	const data = {
		event_name: 'click',
		actionName: eventData.action,
		...eventData
	};

	delete data.action;

	window.__dataLayer.publish('click', {
		event_name: 'click',
		...eventData
	});
};

let storeListeners = {};

storeListeners[actions.BEFORE_LOAD] = () => {
	if (typeof window === 'undefined') return;
	if (accessNested(Store.get(), 'appData.options.enableTealiumCookieConsent')) {
		window.preventCookies = true;
	}
};


storeListeners[actions.PAGE_STATE_LOADED] = () => {
	let { appData, activePage } = Store.get();
	let code = accessNested(appData, 'meta.title.alternateSlug') || appData?.meta?.title?.slug;
	let tealium = appData?.options?.enableTealiumCookieConsent;

	if (appData.options?.enableEnsighten) {
		return ensightenPageViewTrack(activePage.id);
	}

	if (!code || !tealium) return;

	let regionData = accessNested(appData, 'meta.region.slug', '').split('_');
	const pageId = accessNested(activePage, 'id', '');
	let country = regionData[0];
	if (country === 'mde') {
		country = 'xm';
	}
	let language = regionData.pop();
	// Check if the region code has a listed language
	language = languages[language] || language;
	basicTrackingObj = {
		movieName: accessNested(appData, 'meta.title.en'),
		country: country,
		language: language,
		propertyCode: code,
		pageName: pageId
	};

	window.utag_data = { propertyCode: code };
	let type = 'dev';

	if (!__IS_LOCAL__ && !__IS_DEMO__) {
		type = location.href.indexOf('stage.showtimes-static') !== -1 ? 'qa' : 'prod';
	}

	let profile = null;
	if (country === 'au') {
		profile = 'au-powster';
	} else profile = Object.keys(profilesCountries).find(profile => profilesCountries[profile].indexOf(country) !== -1);
	if (!profile) return;
	let scriptUrl = '//tags.disneyinternational.com/tealium/'+profile+'/'+type+'/utag.js';

	let script = document.createElement('script');
	script.onload = pageViewTrack;
	script.async = true;
	script.src = scriptUrl;
	document.body.appendChild(script);
};

// ------- PAGE CHANGE -------

storeListeners[actions.SET_ACTIVE_PAGE] = (page) => {
	if (Store.get().appData?.options?.enableEnsighten) {
		return ensightenPageViewTrack(page.id);
	}

	pageViewTrack({
		pageName: page.id,
		tealium_event: "internal_link"
	});
};


// ------- THEATER SELECTION -------

// Dirty trick to detect theater selection from map
let theaterSelectedFromMap = false;
storeListeners['TRACK_MAP_THEATER_CLICK'] = () => theaterSelectedFromMap = true;
storeListeners[actions.SELECT_THEATER] = (theaterId) => {
	actionTrack({
		action: theaterSelectedFromMap ? 'placeSelectFromMap' :  'cinemaSelect',
		...theaterData(theaterId)
	});
	theaterSelectedFromMap = false;
};


// ------- DATE SELECTION -------

storeListeners[actions.SELECT_ST_DATE] = (stDate) => {
	if (!stDate) return;
	actionTrack({
		action: 'dateSelect',
		...theaterData(),
		dateSelected: formatDateTime(stDate.date, 'yyyy-MM-dd')
	});
};


// ------- TIME SELECTION -------

storeListeners[actions.SELECT_TIME] = (theater, screening) => {
	if (!screening) return;
	let format = accessNested(screening, 'movie.format.slug');
	actionTrack({
		action: 'timeSelect',
		...theaterData(theater),
		targetLink: screening.url,
		format: format,
		showDateTime: screening.datetime && formatDateTime(screening.datetime, 'yyyy-MM-dd\\THH:mm:ss'),
		dateSelected: screening.stDate && formatDateTime(screening.stDate.date, 'yyyy-MM-dd')
	});
};


// ------- CITY SELECTION -------

storeListeners[actions.SELECT_NEARBY_CITY] = (geo) => {
	actionTrack({
		action: 'moreShowTimes',
		location: geo && geo.city
	});
};


// ------- FILTERS -------

function filterUpdateTrack(data) {
	let fullList = Store.get().showtimes.theaters;
	if (!fullList) {
		return;
	}
	let visibleList = fullList.filter(t => t && t.enabled && t.filteredScreenings && t.filteredScreenings.length);
	actionTrack({
		...data,
		searchResults: visibleList.length
	});
}
storeListeners[actions.SEARCH_NEW_CITY] = (searchPhrase) => {
	Store.once(actions.SET_THEATERS, () => {
		filterUpdateTrack({
			action: 'cinemaSearch',
			searchPhrase
		});
	});
};
storeListeners[actions.TOGGLE_FILTER] = (type, options) => {
	if (type === 'format' && options && options[0]) {
		Store.once(actions.AFTER_THEATERS_UPDATE, () => {
			filterUpdateTrack({
				action: 'formatSelect',
				format: options[0].slug
			});
		});
	}
};
storeListeners[actions.RESET_FILTER] = (type) => {
	if (type === 'format') {
		Store.once(actions.AFTER_THEATERS_UPDATE, () => {
			filterUpdateTrack({
				action: 'formatSelect',
				format: 'all'
			});
		});
	}
};

// ------- YOUTUBE -------
let tealium_event;
function fireUtag(tealium_event, time, id, length, data, milestone) {
	if (!window.utag || typeof window.utag.link !== 'function' || typeof window.utag.DB !== 'function') return;
	let isMilestoneEvent = tealium_event === 'video_milestone' ? `, Milestone=${milestone.toString()}` : '';
	window.utag.DB(`Video event: ${tealium_event}, video ID: ${id}${isMilestoneEvent}`);
	window.utag.link(
		{
			tealium_event: tealium_event,
			video_playhead: time.toString(),
			video_id: id,
			video_length: length.toString(),
			video_name: data.title,
			video_platform: 'YouTube'
		}
	);
}
storeListeners[actions.YOUTUBE_PROGRESS] = (time, id, length, data) => {
	if (time < 1) {
		tealium_event = 'video_start';
		fireUtag(tealium_event, time, id, length, data);
	} else if (time === 100) {
		tealium_event = 'video_complete';
		let playhead = (time / 100) * length;
		fireUtag(tealium_event, playhead, id, length, data);

	} else {
		tealium_event = 'video_milestone';
		let playhead = (time / 100) * length;
		fireUtag(tealium_event, playhead, id, length, data, time);
	}
};
storeListeners[actions.YOUTUBE_PAUSE] = (length, playhead, data) => {
	tealium_event = 'video_pause';
	fireUtag(tealium_event, playhead, data.video_id, length, data);
};
storeListeners[actions.YOUTUBE_PLAY] = (id, length, playhead, data) => {
	tealium_event = 'video_play';
	fireUtag(tealium_event, playhead, data.video_id, length, data);
};

export {
	staticRender,
	storeListeners
};
